import React from 'react';
import PropTypes from 'prop-types';
import { Carousel, CtaButton, CtaShell } from '@web/molecules';
import { Endorsement } from './Endorsement';
import {
  EndorsementsOutsideContainer,
  Headline,
  GetStartedContainer,
} from './styles';

export const Endorsements = ({
  headline,
  endorsements,
  link,
  level,
  backgroundColor,
  typography = 'heading1',
  fontColor,
  endorsementsTypography = 'heading3',
  endorsementsFontColor,
}) => {
  const dotImages = endorsements.map(e => e.photo);

  return (
    <EndorsementsOutsideContainer $backgroundColor={backgroundColor}>
      <Headline $typography={typography} $fontColor={fontColor} as={level}>
        {headline}
      </Headline>
      <Carousel itemsToShow={1} showArrows={false} dotImages={dotImages}>
        {endorsements.map(e => (
          <Endorsement
            {...e}
            key={e.name}
            typography={endorsementsTypography}
            fontColor={endorsementsFontColor}
          />
        ))}
      </Carousel>
      {link && (
        <GetStartedContainer>
          <CtaShell
            alignment={link.alignment}
            fullWidth={link.fullWidth}
            fullWidthMobile={link.fullWidthMobile}
            fullWidthDesktop={link.fullWidthDesktop}
          >
            <CtaButton
              {...link}
              variant={link.variant}
              headerText={link.headerText}
              href={link.target}
              icon={link.icon}
              iconAlignment={link.iconAlignment}
            >
              {link.text}
            </CtaButton>
          </CtaShell>
        </GetStartedContainer>
      )}
    </EndorsementsOutsideContainer>
  );
};

Endorsements.displayName = 'Endorsements';

Endorsements.propTypes = {
  headline: PropTypes.string.isRequired,
  endorsements: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      photo: PropTypes.object.isRequired,
    }),
  ).isRequired,
  link: PropTypes.shape({
    target: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
  level: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']),
};
